export default __webpack_public_path__ + "static/media/landing-bg.39a89603.png";